import { useNavigate } from 'react-router-dom';
import { ORG_META, getOrg, setOrg } from '../lib/org';

export const OrgSwitcher = ({ orgs }) => {
  const navigate = useNavigate();
  const cur = getOrg();
  if (!orgs || orgs.length < 2) return null;
  const pick = (o) => {
    if (o === cur) return;
    setOrg(o);
    navigate(o === 'ludo' ? '/ludo/dashboard' : '/dashboard', { replace: true });
    window.location.reload();
  };
  return (
    <div className="mx-4 mb-2 p-1 rounded-full bg-white/70 border border-[#E5E0EA] flex" data-testid="org-switcher">
      {orgs.map((o) => (
        <button key={o} onClick={() => pick(o)} data-testid={`org-switch-${o}`}
          className={`flex-1 flex items-center justify-center gap-1.5 text-[12px] font-semibold rounded-full py-1.5 transition-colors ${
            o === cur ? 'bg-[#5E5068] text-white shadow-sm' : 'text-[#6E5F78] hover:bg-[#F1EDF5]'}`}>
          <img src={ORG_META[o].logo} alt="" className="w-4 h-4 rounded-full" />
          {ORG_META[o].name}
        </button>
      ))}
    </div>
  );
};

export default OrgSwitcher;
